import preloadImages from '../lib/preloadImages';
import { cdnUrl, imagesBucketUrl } from './env';

export const CDNFitOption = Object.freeze({
  contain: 'contain',
  cover: 'cover',
  fill: 'fill',
  inside: 'inside',
  outside: 'outside',
});

export default function getUrlFromCdn(url, { width, height, fit } = {}) {
  if (!url) return url;

  const params = new URLSearchParams();

  if (width) params.append('width', width);
  if (height) params.append('height', height);
  if (fit) params.append('fit', fit);

  return `${url.replace(imagesBucketUrl, cdnUrl)}?${params.toString()}`;
}

// An omitted height means "keep the picture's proportions" — the CDN crops to
// whatever box it is given, so asking for one is how an image gets squared.
// getUrlFromCdn already drops a falsy height; this builds its URLs by hand, so
// it has to do the same.
export function generateSrcSetUrls({ url, width, height }) {
  const at = scale => {
    const params = new URLSearchParams();
    params.append('width', width * scale);
    if (height) params.append('height', height * scale);
    return `${url}?${params.toString()}`;
  };

  return { '1x': at(1), '2x': at(2) };
}

export function generateSrcSet({ url, width, height }) {
  const urls = generateSrcSetUrls({ url, width, height });
  return Object.keys(urls)
    .reduce((prev, key) => {
      prev += `${urls[key]} ${key},`;
      return prev;
    }, '')
    .slice(0, -1);
}

export function getImageSrcAndSrcSet({ url, width, height, isPreview = false }) {
  if (url == null) return;

  const src = getUrlFromCdn(url, {
    width,
    height,
  });

  const originalSrc = src.split('?')[0];

  if (isPreview) {
    const urls = generateSrcSetUrls({ url: originalSrc, width, height });
    preloadImages({ urls: Object.values(urls) }).catch(err => console.error(err));
  }

  return {
    src,
    srcSet: generateSrcSet({
      url: originalSrc,
      width,
      height,
    }),
  };
}

export function stripQueryStringFromCdnUrl(string) {
  if (string == null || typeof string !== 'string') return string;

  return string.replace(
    /(https:\/\/d28vp4zm2cqb0r\.cloudfront\.net\/[^"'\s]+?)(\?[^"'\s]+)/g,
    '$1',
  );
}
